import { fetchStringToFile } from './fetchStringToFile'

const isAbsoluteUrl = (value: string) => /^https?:\/\//i.test(value)

export async function download(url: string, filename: string) {
  const file = isAbsoluteUrl(url)
    ? await fetchStringToFile(filename, 'application/octet-stream', url)
    : await fetchStringToFile(url, filename)

  const blobUrl = URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}

export type DownloadInput =
  | { url: string; name?: string}
  | { file: File }

export async function handleDownload(input: DownloadInput): Promise<void> {
  const name = 'file' in input ? input.file.name : (input.name ?? 'download')

  if ('file' in input) {
    const blobUrl = URL.createObjectURL(input.file)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = name
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
    return
  }

  try {
    await download(input.url, name)
  } catch {
    window.open(input.url, '_blank', 'noopener,noreferrer')
  }
}
